module.exports = __webpack_public_path__ + "static/media/play-button-circle-gray.8ee950de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-button-circle-gray.svg
// module id = 96
// module chunks = 0